import React from 'react'
import { withTranslation } from 'react-i18next';
import userAvatar from '../../images/default_avatar.svg';
import Parent from '../../common/parent';
import Autocomplete from "../../tenants/map/autocomplete";
import $ from 'jquery';
import {BllinkLogger} from "../../common/utils/bllink_loggers";
import './newBuildingDetails.css';
import PlusIcon from "../../images/plus.png";
import { constants } from "../../common/constants/constants";
import NewBuildingLogic from "./newBuildingLogic";
import NewBuildingAddressPopUp from './NewBuildingAddressPopUp';
import NewAddress from './NewAddress';
import {fileToBase64} from '../../../utils/fileToBase64';

class NewBuildingDetails extends Parent{

    constructor(props) {
        super(props);

        this.readURL.bind(this);
        this.bindClickNewRow.bind(this);
        this.state = {
            managerRows: 1,
            photosUploaded: [{}],
            addressPopUp: false,
            addressPart: []
        };
    }

    closeAddressModal = () => {
        this.setState({
            ...this.state,
            addressPopUp: false
        })
    }

    openAddressModal = () => {
        this.setState({
            ...this.state,
            addressPopUp: true
        })
    }

    async componentDidMount(){
        await this.verifyLoggedIn()
        const isAdmin = await this.isAdmin();
        this.setState({
            ...this.state,
            isAdmin
        });
        this.bindPhotoUpload();
        this.bindClickNewRow();
        this.ignoreEnterPressed();
        this.bindTypingPhotoTitle();
        this.bindTypingEntrance();
        this.validator = NewBuildingLogic.validateCreateForm(null, this);
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        NewBuildingLogic.validateCreateForm(this.validator, this);
    }

    bindTypingPhotoTitle(){
        const thisObj = this;
        setTimeout(()=> {
            $('.js-photo-title').keyup((e) => {
                const rowIndex = $(e.target).attr('row');
                BllinkLogger.info(`manager-name ${$(e.target).val()}`)
                thisObj.state.photosUploaded[rowIndex].fullName = $(e.target).val();

                BllinkLogger.info(` photosUploaded`, thisObj.state.photosUploaded);
            })
        },500)
    }

    bindTypingEntrance(){
        const thisObj = this;
        setTimeout(()=> {
            $('#entrance_number').keyup((e) => {
                BllinkLogger.info(`entrance ${$(e.target).val()}`)
                thisObj.setState({entrance: $(e.target).val()})
                BllinkLogger.info(` photosUploaded`, thisObj.state);
            })
        },500)
    }

    bindClickNewRow(){
        const thisObj = this;
        $('.js-add-new-btn').click(function(e){
            thisObj.setState({
                managerRows: thisObj.state.managerRows + 1,
                photosUploaded: thisObj.state.photosUploaded.concat({})
            })
            BllinkLogger.info(`new state is `, thisObj.state);
            thisObj.bindPhotoUpload();
            thisObj.bindTypingPhotoTitle();
        })
    }

    ignoreEnterPressed(){
        $('form#js-new-building').bind('keypress keydown keyup', function(e){
            if(e.keyCode === 13) { e.preventDefault(); }
        });

    }

    async readURL(input) {
        const thisObj = this;
        const rowIndex = $(input).attr('row');
        BllinkLogger.info(`rowNumber ${rowIndex}`);

        if (input.files && input.files[0]) {
            const imageBase64 = await fileToBase64(input.files[0], true);
            const name = input.files[0].name;
            $(`.js-user-logo-${rowIndex}`).attr('src', imageBase64);
            await thisObj.uploadPhoto(thisObj, imageBase64, name, rowIndex);
        }
    }

    async uploadPhoto(thisObj, imageBase64, name, rowIndex){
        thisObj.startLoader();
        // todo upload to s3, get key and add to list
        const uploadResult = await thisObj.client.put('/images/upload', { imageBase64, name });
        thisObj.endLoader();
        BllinkLogger.info(`uploadResult`, uploadResult);

        thisObj.state.photosUploaded[rowIndex] = {
            "fullName": $(`.js-manager-name-${rowIndex}`).val(),
            "hostType": "ועד", // hard coded for now. not sure how it's used
            "avatarKey": uploadResult.filesKey
        }

    }

    bindPhotoUpload(){

        const thisObj = this;
        $(".js-upload-manager-photo").unbind('change').bind('change', function(){
            thisObj.readURL(this);
        });

        $('.manager-host-image').unbind('click').bind('click', function(){
            const rowIndex = $(this).attr('row');
            $(`.js-image-input-${rowIndex}`).trigger('click');
        });
    }


    async submitCreateBuildingForm(){
        //collect user data
        let data = this.createBuildingPayload();
        BllinkLogger.info(`data to send `, data);
        // upload photos and get host avatar keys

        if (data) {
            // send data to api
            this.startLoader();
            const response = await this.client.put('/managers/buildings', data);
            this.endLoader();
            BllinkLogger.info(`clicked create new response is `, response);
            if (this.state.isAdmin) {
                if (response.buildingID) this.props.history.push(`/${constants.pages.addBankDetailsUrl}/${response.buildingID}`);
            } else this.props.history.push(`/${constants.pages.allBuildingsUrl}`);         
        }
    }

    createBuildingPayload(){
        const {t} = this.props;
        BllinkLogger.info(`createBuildingPayload state`, this.state)

        if (!this.state.addressComponents){
            if (this.state.isAdmin) {
                this.setState({
                    ...this.state,
                    addressPopUp: true
                })
            }
            else alert(t(`errors.tenant.search.SearchAddressIsNotCompleted`))
            return
        }


        return {
            "address_components": this.state.addressComponents,
            "address_data": this.state.addressData,
            "entrance": this.state.entrance,
            "hosts": this.state.photosUploaded,
            "AgreeToAds": true
        }
    }


    async placeChanged(place){
        /*
            setting on the component instance to be later searched by
        */
        BllinkLogger.info(`place `, place);

        let latitude = place.geometry.location.lat();
        let longitude = place.geometry.location.lng();
        BllinkLogger.info(`lat ${place.geometry.location.lat()} and lng ${place.geometry.location.lng()}`);
        // todo validate is specific place before continue
        const validation = this.validateBeforeSearch(place.address_components);
        if (validation.result) {
            this.setState({
                addressComponents: place.address_components,
                addressData: {latitude: latitude, longitude: longitude},
                entrance: $('#entrance_number').val()
            })
        } else {
            if (this.state.isAdmin) {
                this.setState({
                    ...this.state,
                    addressPart: place.address_components,
                    addressData: {latitude: latitude, longitude: longitude},
                    entrance: $('#entrance_number').val()
                })
            }
        }
    }

    renderTitle(){
        const {t} = this.props;

        if (!this.state.userCheck){
            return <div/>
        }

        return (
            <section>
                <div className="container">
                    <div className="row">
                        <div className="bank_d col-md-12">
                            <h2 className="text-center">{t('buildings.new_building_details')}</h2>
                            <p>
                                {t('buildings.opening_building') + ' '} {t('buildings.enable_building_today')}
                            </p>
                        </div>
                    </div>
                </div>
            </section>
        )
    }

    renderRow(index){
       const {t} = this.props;

       return <div className="row">
            <div className="form-group col-4">
                <label htmlFor="Email">{t('buildings.building_manager_name')}: </label>
                <input type="text" autoComplete="name"
                       row={index} className={`form-control bllink-input-border js-photo-title js-manager-name-${index}`}
                       name={`building-manager-${index}`}
                />
            </div>
            <div className="form-group col-2">
                <img alt="user" id="user-logo"
                     row={index} className={`manager-host-image clickable center js-user-logo-${index}`}
                     src={userAvatar}/>
            </div>
            <div className="form-group col-4">
                <div className="form-group set_img_add">
                    <button name="tenant_type" id="add_img">
                        {t('buildings.adding_another_manager')}
                        <input type="file" id="imgInp" accept="image/*" row={index} className={`file_upload-input js-upload-manager-photo js-image-input-${index} clickable`} />
                    </button>
                </div>
            </div>
        </div>
    }

    render() {
        const {t} = this.props;

        return (
            <div>
                {this.renderTitle()}
                <section>
                    <div className="container">
                        <div className="col-md-12">
                            <div className="step-inner-bank_detail">
                                <form id="js-new-building">
                                    <div className="row">
                                        <div className="step_from col-10">
                                            <div className="row">
                                                <div className="form-group col-8">
                                                    <div className="form-group step-bnk-detail">
                                                        <label htmlFor="email">{t('buildings.full_address')}:</label>
                                                        <Autocomplete onPlaceSelected={(place) => this.placeChanged(place)}/>
                                                        <label id="address-error" className="error" htmlFor="address"/>
                                                    </div>
                                                </div>
                                                <div className="form-group col-3">
                                                    <div className="step_1">
                                                        <label htmlFor="email">{t('buildings.entrance_optional')}</label>
                                                        <input type="text" name="entrance_number" id="entrance_number" className="form-section small-input" />
                                                    </div>
                                                </div>
                                            </div>
                                            {[...Array(this.state.managerRows).keys()].map((value, index) => {
                                                return this.renderRow(index)
                                            })}

                                            <div className="row">
                                                <div className="col-sm-6">
                                                    <div className="" id="addBtn-new" type="button">
                                                        <img id="addBtn" className="js-add-new-btn" src={PlusIcon} alt={"new line"}/>
                                                    </div>

                                                </div>

                                            </div>
                                        </div>

                                    </div>
                                    <div className="step_bank_btn">
                                        <div className="row">
                                            <div className="col-sm-6">
                                            </div>
                                            <div className="col-sm-6">
                                                <div className="form-group new_btn_set_2">
                                                    <input type="submit" name="sign-in" id="create-new-building"
                                                           value={t('buildings.open_new_building')}/>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </section>

                <NewBuildingAddressPopUp
                    show={this.state.addressPopUp}
                    onHide={this.closeAddressModal}
                >
                    <NewAddress 
                        address={this.state.addressPart}
                        entranceNumber={this.state.entrance}
                        photos={this.state.photosUploaded}
                        addressData={this.state.addressData}
                        modal
                    />
                </NewBuildingAddressPopUp>
            </div>
        )
    }
}

export default withTranslation()(NewBuildingDetails)
